import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {

  workflowurl = environment.workflowUrl

  constructor( 
    private http: HttpClient
  ) { }



  getWorkFlowGroups()
  {
    return this.http.get(this.workflowurl + '/workflow/group/all');
  }

  getWorkFlowGroup(groupId)
  {
    return this.http.get(this.workflowurl + '/workflow/group/' + groupId);
  }

  createNewGroup(reqBody, userId)
  {
    return this.http.post(this.workflowurl + '/workflow/group/create/new/' + userId, reqBody);
  }

  editWorkFlowGroup(workflowId, reqBody, userId)
  {
    return this.http.put(this.workflowurl + '/workflow/group/update/' + workflowId + '/' + userId, reqBody)
  }

  createAssigneeTask(assigneeTask, isAccept) {
    return this.http.post(this.workflowurl + '/workflow/assignee/task/'+isAccept, assigneeTask, { responseType: 'json' });
  }

  getAssignedTasks(userId) {
    return this.http.get(this.workflowurl + '/workflow/assignee/task/'+userId);
  }

  getTaskById(taskId, instanceId) {
    return this.http.get(this.workflowurl + '/workflow/task/'+taskId+"/"+instanceId);
  }

  saveTask(taskRequest) {
    return this.http.post(this.workflowurl + '/workflow/assignee/task/save', taskRequest, { responseType: 'json' });
  }

  executeTemplate(body)
  {
    return this.http.post(this.workflowurl + '/workflow/node/execute' , body);
  }

  getStartVariables(id: string)
  {
    return this.http.get(this.workflowurl + '/workflow/start/variable/' + id);
  }

  uploadFile(formData: any) {
    return this.http.post(this.workflowurl + '/artifacts/upload', formData, { responseType: 'text' });
  }
  
  downloadFile(fileName: string) {
    return this.http.get(this.workflowurl + '/artifacts/download/'+fileName, { responseType: 'blob' });
  }

  getAllActiveCustomers() {
    return this.http.get(this.workflowurl + '/user/all');
  }

  getRunningIdentifier(request: any) {
    return this.http.post(this.workflowurl + '/workflow/identifier/validate', request);
  }

}
